var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".for_bg{background-image:url(" + escape(require("./assets/photo_1.jpg")) + ");background-position:50%;background-repeat:no-repeat;background-size:cover}.text_wrapper{max-width:570px;padding:0 20px;box-sizing:border-box}.text_wrapper h1{line-height:40px;font-weight:500}.text_wrapper h1 span.about_wr{background-color:#fff;padding:1px 6px}.bold{font-weight:700}span.html_color{color:#fc4011}span.css_color{color:#00b89c}span.js_color{color:#ffca00}span.jq_color{color:#0769ad}span.v_color{color:#42b983}span.r_color{color:#61dafb}span.b_color{color:#563d7c}span.bl_color{color:#00d1b2}@media (max-width:400px){.text_wrapper h1{line-height:30px;font-size:18px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-977256c0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/header.vue
// module id = 23
// module chunks = 0